export default __webpack_public_path__ + "static/media/model-face.3619b436.webp";